<template>
    <g fill="none" fill-rule="evenodd">
        <defs>
            <linearGradient id="94p45x34da" x1="50%" x2="50%" y1="163.811%" y2="1.562%">
                <stop offset="0%" stop-color="#FFF" stop-opacity="0"/>
                <stop offset="100%" stop-color="#EFEFF2"/>
            </linearGradient>
        </defs>
        <g>
            <g>
                <g>
                    <path fill="url(#94p45x34da)" d="M0 114.064h152.043C132.262 95.44 105.487 84 76.022 84 46.556 84 19.782 95.44 0 114.064" transform="translate(-804 -399) translate(703 399) translate(101)"/>
                    <path fill="#DDDFE1" d="M108.418 33.507H64.587c-1.003 0-1.957-.437-2.612-1.197l-7.558-8.77c-1.377-1.599-3.382-2.518-5.492-2.518H35.989c-1.734 0-3.14 1.406-3.14 3.14v68.516c0 1.737 1.396 3.145 3.117 3.145h72.452c1.72 0 3.116-1.408 3.116-3.145V36.653c0-1.738-1.395-3.146-3.116-3.146" transform="translate(-804 -399) translate(703 399) translate(101)"/>
                    <path fill="#E5E7E9" d="M106.713 85.119l-44.436-4.76c-1.482-.16-2.555-1.49-2.397-2.971l6.024-56.223c.159-1.483 1.489-2.556 2.972-2.397l44.436 4.76c1.482.159 2.555 1.49 2.396 2.973l-6.023 56.222c-.16 1.482-1.49 2.555-2.972 2.396" transform="translate(-804 -399) translate(703 399) translate(101)"/>
                    <path fill="#FFF" d="M107.368 33.178L72.904 29.486 73.224 26.503 107.688 30.196zM95.53 39.314L72.22 36.912 72.528 33.927 95.838 36.33z" transform="translate(-804 -399) translate(703 399) translate(101)"/>
                    <path fill="#F0F1F2" d="M114.533 42.66h-67.92c-2.574 0-4.661 2.087-4.661 4.66v48.504h72.581c2.574 0 4.661-2.087 4.661-4.661V47.32c0-2.574-2.087-4.661-4.661-4.661M74.529 6.338L77.529 6.338 77.529-.001 74.529-.001zM85.572 1.455L83.273 7.362 86.069 8.45 88.368 2.543zM63.69 2.542L65.989 8.45 68.785 7.362 66.486 1.454z" transform="translate(-804 -399) translate(703 399) translate(101)"/>
                </g>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: "noDocumentsIcon",
    beforeMount() {
        this.$parent.$emit('size', '0 0 153 115');
    }
}
</script>

<style scoped>

</style>